import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Collapsible from "../components/Collapsible";
import SwiperFunction from "../components/SwiperFunction";
import Cards from "../components/Cards";
import logo from "../images/empire_two.png";
import CenterImage from "../images/center_images.png";
import { Button, Typography } from "@mui/material";
import { PhoneIcon } from "@heroicons/react/24/outline";
import conference from "../images/conference_pic.png";
import { motion } from "framer-motion";

function Home() {
  return (
    <>
      <div className="dark:bg-gray-900">
        {/* <ControlledCarousel /> */}
        <div className="grid place-items-center">
          <img
            src={conference}
            alt=""
            className="scale-y-150 sm:scale-100 sm:h-auto h-80 object-cover object-left"
          />
          <img
            src={logo}
            alt=""
            className="z-10 w-8/12 sm:w-4/12 mt-logo sm:mt-n45"
          />
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <div className="relative mt-3 sm:mt-n">
              <img
                src={CenterImage}
                alt=""
                className="center w-3/4 sm:w-2/4 "
              />
            </div>
          </motion.div>
        </div>
        <strong className="grid place-content-center">
          <div className="mt-5">
            <Button
              variant="outlined"
              className="px-4 py-2 bg-cyan-500 outline-none border border-cyan-100 rounded text-white font-medium active:scale-95
               hover:bg-cyan-400 hover:text-white focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 disabled:bg-gray-400/80 
               disabled:shadow-none disabled:cursor-not-allowed transition-colors duration-200
               "
            >
              <PhoneIcon className="h-5 w-5 mr-2" />
              Call now
            </Button>
          </div>
        </strong>
        {/*  */}
        <div className="mx-4 lg:grid lg:grid-cols-2 lg:gap-4 lg:m-10">
          <div className="text-center md:text-left text-gray-700 ">
            <div className="text-gray-500 whitespace-normal dark:text-gray-400">
              <Typography className="my-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-cyan-500">
                Why Do Business with Empire?
              </Typography>
              <p className="text-gray-500 dark:text-gray-300 text-md sm:text-lg my-5">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi
                voluptatum sequi placeat aliquid quis labore laudantium,
                sapiente vero, asperiores adipisci repellendus. Tempora quasi
                facilis nisi? Et, deleniti laudantium! Possimus, optio. Lorem
                ipsum dolor sit amet consectetur adipisicing elit. Quasi
                voluptatum sequi placeat aliquid quis labore laudantium,
                sapiente vero, asperiores adipisci repellendus. Tempora quasi
                facilis nisi? Et, deleniti laudantium! Possimus, optio. Lorem
                ipsum dolor sit amet consectetur adipisicing elit. Quasi
                voluptatum sequi placeat aliquid quis labore laudantium,
                sapiente vero, asperiores adipisci repellendus. Tempora quasi
                facilis nisi? Et, deleniti laudantium! Possimus, optio.
              </p>
              <Link to="aboutus">
                <Button
                  class="px-4 py-2 bg-transparent outline-none border-2 border-cyan-400 rounded text-cyan-500 font-medium active:scale-95 hover:bg-cyan-600 hover:text-white hover:border-transparent focus:bg-cyan-600 focus:text-white focus:border-transparent focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 disabled:bg-gray-400/80 disabled:shadow-none disabled:cursor-not-allowed transition-colors duration-200"
                  variant=""
                >
                  Read More About us
                </Button>
              </Link>
            </div>
          </div>
          {/* Collapsible */}
          <div className="sm:mx-10 my-10">
            <Collapsible />
          </div>
        </div>
        <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />

        {/* Bio */}

        <div className="m-5 text-center whitespace-normal">
          <Typography className="my-4 text-3xl font-bold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-gray-300">
            AV Rentals
          </Typography>
          <p className="text-gray-500  dark:text-gray-300 sm:mx-10 text-base">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Et id
            impedit ut quas. Assumenda eveniet odit, id sapiente tenetur
            mollitia facere nemo earum eius, laboriosam placeat, pariatur porro
            molestiae aperiam!
          </p>
          <br />
          <Typography className="my-4 text-3xl font-bold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-gray-300">
            AV Labor
          </Typography>
          <p className="text-gray-500 dark:text-gray-300 sm:mx-10 text-base mb-5">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit.
            Perferendis neque voluptatibus tempora qui blanditiis similique ex
            maxime doloremque sunt expedita rerum quia autem, natus saepe porro
            facere consequatur ipsum placeat.
          </p>
          <Button variant="outlined" className="text-cyan-500">
            <PhoneIcon className="h-5 w-5 mr-2" />
            (123)-456-7890
          </Button>
        </div>
        <SwiperFunction />
        <Cards />
        <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
        <div class="grid grid-cols-6 gap-4 sm:gap-12 sponsors grayscale mb-10 ">
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/shure.jpg?ver=2017-06-07-044537-843"
            alt=""
          />
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/images.png?ver=2017-06-07-044537-937"
            alt=""
          />
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/images-1.jpeg?ver=2017-06-07-044538-063"
            alt=""
          />
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/images-6.jpeg?ver=2017-06-07-044537-890"
            alt=""
          />
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/meyer.jpg?ver=2017-06-07-044537-987"
            alt=""
          />
          <img
            src="https://www.poweronav.com/portals/0/Images/logo/qsc.jpg?ver=2017-06-07-044537-783"
            alt=""
          />
        </div>
        <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
        <div className="text-center dark:text-gray-300 dark:bg-gray-900">
          <p>
            Dallas area audio visual production company serving Forth Worth &
            Dallas Metroplex
          </p>
        </div>
        <div className="grid place-content-center mt-5 ">
          <Button variant="outlined" className="text-cyan-500 my-5">
            <PhoneIcon className="h-5 w-5 mr-2" />
            (123)-456-7890
          </Button>
        </div>
      </div>
    </>
  );
}

export default Home;
